import isFormatSupported from "@/utils/isFormatSupported";
import preloadImage from "@/utils/preloadImage";
import asyncTimeout from "@/utils/asyncTimeout";

export default function (element, data) {
    const oldFrameElement = element.querySelector(".cinemagraph-scroll-old-frame");
    const currentFrameElement = element.querySelector(".cinemagraph-scroll-current-frame");
    const framesNum = data.framesNum;
    const baseUrl = data.baseUrl;
    let currentFrame = null;
    let targetFrame = 1;

    let format = "avif";
    (async function () {
        if (await isFormatSupported("avif")) {
            format = "avif";
        } else if (await isFormatSupported("webp")) {
            format = "webp";
        } else {
            format = "png";
        }

        await preloadFrames(baseUrl, framesNum, format);

        async function tick() {
            if (currentFrame != targetFrame) {
                currentFrame = currentFrame || targetFrame;

                const oldImageUrl = formatFrameUrl(baseUrl, format, currentFrame);

                if (currentFrame < targetFrame) {
                    currentFrame++;
                } else if (currentFrame > targetFrame) {
                    currentFrame--;
                }

                const newImageUrl = formatFrameUrl(baseUrl, format, currentFrame);

                await crossFade(oldFrameElement, currentFrameElement, oldImageUrl, newImageUrl, 33.333333333);
            } else {
                await asyncTimeout(30);
            }

            tick();
        }

        tick();
    })();

    function updateOnScroll() {
        const viewportHeight = window.innerHeight;
        const rect = element.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, -(rect.y / (rect.height - viewportHeight))));
        targetFrame = Math.floor((progress * (framesNum - 1)) + 1);
    }

    window.addEventListener('scroll', updateOnScroll);
    updateOnScroll();

    /*
    window.test = function () {
        targetFrame = ((currentFrame || 0) + 1) % 44;
    };
    */
};

async function preloadFrames(baseUrl, framesNum, format) {
    for (let i = 1; i <= framesNum; i++) {
        const currentFrameUrl = formatFrameUrl(baseUrl, format, i);
        await preloadImage(currentFrameUrl);
    }
}

function formatFrameUrl(baseUrl, format, frameNumber) {
    const paddedFrameNumber = ('0000' + frameNumber).slice(-4);
    return baseUrl + "/" + format + "/frame_" + paddedFrameNumber + "." + format;
}

async function crossFade(oldImg, newImg, oldImageUrl, newImageUrl, duration) {
    oldImg.src = oldImageUrl;
    newImg.src = newImageUrl;
    
    oldImg.style.opacity = '1';
    newImg.style.opacity = '0';

    //await asyncTimeout(1);

    oldImg.style.transition = `opacity ${duration / 2}ms linear`;
    newImg.style.transition = `opacity ${duration / 2}ms linear`;
    
    //await asyncTimeout(1);
    
    newImg.style.opacity = '1';
    
    /*
    await new Promise(resolve => {
        const handler = (e) => {
            if (e.target === newImg && e.propertyName === 'opacity') {
                newImg.removeEventListener('transitionend', handler);
                resolve();
            }
        };
        newImg.addEventListener('transitionend', handler);
    });
    */

    await asyncTimeout(duration / 2);
    
    oldImg.style.opacity = '0';
    
    /*
    await new Promise(resolve => {
        const handler = (e) => {
            if (e.target === oldImg && e.propertyName === 'opacity') {
                oldImg.removeEventListener('transitionend', handler);
                resolve();
            }
        };
        oldImg.addEventListener('transitionend', handler);
    });
    */

    await asyncTimeout(duration / 2 + 1);
    
    oldImg.style.transition = '';
    newImg.style.transition = '';
}
